import { Outlet } from 'react-router-dom';

import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';

export const ComplianceFrameworksPageWrapper = () => {
  const menuItems = useMenuItems();

  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer>
      <Outlet />
    </SignedInPageLayout>
  );
};
